import { Link } from "react-router-dom";
import { MapPin, Package, RotateCcw, ShieldAlert, Wallet } from "lucide-react";

const Section = ({ icon: I, title, children, id }) => (
  <section className="border-t pt-8" data-testid={`returns-${id}`}>
    <h2 className="flex items-center gap-3 font-heading text-2xl font-black uppercase tracking-tight"><I className="w-5 h-5 text-verde" />{title}</h2>
    <div className="mt-4 space-y-3 text-slate-700 leading-relaxed">{children}</div>
  </section>
);

export default function Returns() {
  return (
    <div className="mx-auto max-w-3xl px-4 sm:px-6 py-14" data-testid="returns-page">
      <p className="eyebrow">Atención al cliente</p>
      <h1 className="mt-2 font-heading text-4xl sm:text-5xl font-black uppercase tracking-tight">Política de devoluciones</h1>
      <div className="mt-8 grid sm:grid-cols-3 gap-3 text-sm" data-testid="returns-summary">
        <div className="bg-white border p-4"><p className="font-bold text-brand text-2xl">15 días</p><p className="text-slate-500">para cambios y devoluciones</p></div>
        <div className="bg-white border p-4"><p className="font-bold text-brand text-2xl">2 formas</p><p className="text-slate-500">en tienda o por mensajería</p></div>
        <div className="bg-white border p-4"><p className="font-bold text-brand text-2xl">14 días</p><p className="text-slate-500">máximo para tu reembolso</p></div>
      </div>

      <div className="mt-12 space-y-10">
        <Section icon={RotateCcw} title="Plazo" id="plazo">
          <p>Dispones de <strong>15 días naturales</strong> desde que recibes tu pedido para cambiarlo o devolverlo, sin necesidad de indicar el motivo.</p>
          <p>Los artículos deben estar <strong>sin usar, en perfecto estado y con sus etiquetas y embalaje original</strong> (en el calzado, también la caja). Incluye el número de pedido (por ejemplo SS-123456).</p>
        </Section>

        <Section icon={MapPin} title="Cómo devolver" id="como">
          <p><strong>1. En nuestra tienda:</strong> trae el artículo y tu número de pedido a C/ Granada, nº 4 - Local 3, 04860 Olula del Río (Almería). Es gratis y podemos hacerte el cambio al momento.</p>
          <p><strong>2. Por mensajería o correo:</strong> avísanos antes en <a href="mailto:sobrinosport@gmail.com" className="underline">sobrinosport@gmail.com</a> o al <a href="tel:+34661666916" className="underline">661 666 916</a> y envía el paquete a la dirección de la tienda. <strong>Los gastos de envío de la devolución corren a cargo del cliente.</strong> Te recomendamos un envío con seguimiento.</p>
        </Section>

        <Section icon={Wallet} title="Reembolso" id="reembolso">
          <p>Una vez recibido y revisado el artículo, te devolvemos el importe <strong>por el mismo medio de pago</strong> que usaste, en un plazo máximo de <strong>14 días</strong>.</p>
          <p>Si devuelves el pedido completo, también te reembolsamos los gastos de envío estándar de la compra. Podemos retener el reembolso hasta recibir el artículo.</p>
        </Section>

        <Section icon={ShieldAlert} title="Artículos que no admiten devolución" id="excluidos">
          <ul className="list-disc pl-5 space-y-1">
            <li><strong>Ropa interior y bañadores</strong>, por motivos de higiene, cuando se haya retirado su precinto o etiqueta de protección.</li>
            <li><strong>Artículos personalizados</strong> (con nombre, número u otras modificaciones a petición del cliente).</li>
          </ul>
        </Section>

        <Section icon={Package} title="Artículos del Outlet" id="outlet">
          <p>Los artículos del Outlet son últimas unidades y <strong>no admiten cambios</strong> por otra talla o modelo.</p>
          <p>En compras online conservas el <strong>derecho legal de desistimiento de 14 días naturales</strong> con reembolso, en las mismas condiciones de estado del artículo y con los gastos de devolución a tu cargo.</p>
        </Section>

        <section className="border-t pt-8 text-sm text-slate-500" data-testid="returns-legal">
          <p>Esta política no limita los derechos que te reconoce la normativa de consumidores (Real Decreto Legislativo 1/2007), incluido el derecho de desistimiento de 14 días en compras a distancia y la garantía legal de 3 años por falta de conformidad. Puedes ejercer el desistimiento con cualquier declaración clara, por ejemplo por email.</p>
          <p className="mt-2">Sobrino Sport · Jorge Sobrino Hernández · NIF 75227763F · C/ Granada, nº 4 - Local 3 · 04860 Olula del Río (Almería)</p>
        </section>
      </div>
      <Link to="/tienda" className="btn-primary mt-12 inline-flex" data-testid="returns-shop-link">Volver a la tienda</Link>
    </div>
  );
}
